import Glide, { Autoplay, Controls, Breakpoints, Swipe } from '@glidejs/glide/dist/glide.modular.esm';
require("../../scss/app-registration.scss");

import Application from "./application";
import AddressLookup from "../jsx/address-lookup/address-lookup";
import ShortlistCount from "../jsx/shortlist/shortlist-count";
import BackgroundImageBehaviour from '../behaviours/background-image-behaviour';
import MobileMenuBehavior from "../behaviours/mobile-menu-behaviour";
import EqualizeBehavior from "../behaviours/equalize-behaviour";
import TogglePasswordBehavior from "../behaviours/togglle-password-field";
import UrlParameterHandlerBehaviour from "../behaviours/url-parameter-handler-behaviour";


let config = {};
config.behaviours = {
    "BackgroundImage": new BackgroundImageBehaviour(),
    "MobileMenuBehaviour": new MobileMenuBehavior(),
    "EqualizeBehaviour": new EqualizeBehavior(),
    "TogglePasswordBehavior": new TogglePasswordBehavior(),
    "UrlParameterHandlerBehaviour": new UrlParameterHandlerBehaviour()
};
config.components = {
    "shortlist-count": ShortlistCount,
    "address-lookup": AddressLookup,
}

new Application(config);

window.glide = {};
if(document.querySelector('.review-slider')) {
    window.glide.reviewSlider =  new Glide('.review-slider', {autoplay: false, gap: 0, perView: 2, bound: true, breakpoints: { 740: { perView: 1}  }})
        .mount({Autoplay, Controls, Breakpoints, Swipe})
        .on('run.after', () => { window.lazy.update() });
}
if(document.querySelector('#register-usp-slider')){
    window.glide.awards = new Glide('#register-usp-slider', {
        animationDuration: 300,
        autoplay: 3000,
        bound: true,
        perView: 1,
    }).mount({
        Controls,
        Breakpoints,
        Autoplay
    });
}